import React, {useEffect, useRef, useState} from 'react';
import Header from '../../../components/layout/headers/Header'
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation"
import CreateNewPolicyPage from "./create/CreateNewPolicyPage"
import apiClient from "../../../services/api-client";
import {Divider} from 'primereact/divider';
import {Button} from 'primereact/button';
import AppCard from '../../../components/ui/AppCard';
import InfoField from '../../../components/ui/InfoField';
import StatusBadge from '../../../components/ui/StatusBadge';
import localBGImage from "../../../assets/images/patterns/applyPolicy.png"
import logoImg from '../../../assets/images/logo.png';
import {Skeleton} from 'primereact/skeleton';
import Menu from '../../../components/common/Menu';
import {useMountEffect} from 'primereact/hooks';
import {Dialog} from 'primereact/dialog';
import localBGImageBeneficiaries from "../../../assets/images/patterns/beneficiaries-bg.png"
import {Accordion, AccordionTab} from 'primereact/accordion';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import AddBeneficiaryMembers from "./create/components/policyForm/AddBeneficiaryMembers.jsx";
import {ConfirmPopup} from 'primereact/confirmpopup';
import {Toast} from 'primereact/toast';
import StorageHelper from '../../../utils/storage-helper';
import {addBeneficiary, deleteBeneficiary, editBeneficiary} from '../../../services/beneficiary-service';
import { getPolicyStatusLabel, getPolicyStatusTone, getPolicyStatusMessage } from '../utils/policyStatus';
import { policyMenuTrigger } from '../components/policyMenuTrigger';
import { fetchFullPolicy, drawCertificate } from '../utils/policyCertificate';
import BeneficiaryDialog from "../components/BeneficiaryDialog";

function NewApplicationPolicyDisplay(existingApplicationProgress) {
    //console.log("UPDATE  APPLICATION ");
    //console.log(existingApplicationProgress);
    return (
        <CreateNewPolicyPage className="mt-2" existingApplicationProgress={existingApplicationProgress}/>
    );
}

const CHILD_COLUMNS = [
    ['ID_num', 'ID Number'], ['Name', 'First Name'], ['Surname', 'Last Name'],
    ['Date_of_birth', 'Date Of Birth'], ['Gender', 'Gender'], ['AtVarsity', 'Is Tertiary Student'],
];
const EXTENDED_COLUMNS = [
    ['ID_num', 'ID Number'], ['Name', 'First Name'], ['Surname', 'Last Name'],
    ['Date_of_birth', 'Date Of Birth'], ['Gender', 'Gender'], ['Relation', 'Relationship'],
];
const OTHER_COLUMNS = [
    ['IdNumber', 'ID Number'], ['Title', 'Title'], ['FirstName', 'First Name'], ['Surname', 'Last Name'],
    ['DateOfBirth', 'Date Of Birth'], ['Gender', 'Gender'], ['Relationship', 'Relationship to Principal'],
    ['Telephone', 'Telephone'],
];

// One table per beneficiary under a heading, or an empty-state hint when there are none.
function BeneficiaryGroup({title, emptyText, items, keyField, columns, relationshipType, actionBodyTemplate}) {
    if (!items || items.length === 0) {
        return <><small className="dl-empty-hint">{emptyText}</small><Divider type="dotted"/></>;
    }

    return <>
        <h4 className='dl-beneficiary-subheading'>{title}</h4>
        {items.map((beneficiary) => (
            <React.Fragment key={beneficiary[keyField]}>
                <Divider type="dotted"/>
                <DataTable value={[beneficiary]} tableStyle={{minWidth: '50rem'}}>
                    {columns.map(([field, header]) => <Column key={field} field={field} header={header}></Column>)}
                    <Column header="Actions"
                            body={(rowData) => actionBodyTemplate(rowData, relationshipType)}/>
                </DataTable>
            </React.Fragment>
        ))}
    </>;
}

function EasipolPolicyDisplay({policyList, policyDisplayKey, apiResponse, updateSelectedPolicy, openAddDialog, actionBodyTemplate, generateCertificate}) {
    const currentPolicy = policyList?.[policyDisplayKey];
    const currentMember = currentPolicy?.MainMember;
    const statusLabel = getPolicyStatusLabel(currentMember?.Status);
    const statusTone = getPolicyStatusTone(currentMember?.Status);
    const statusMessage = getPolicyStatusMessage(currentMember);


    return (<>
        {policyList ?
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-8">
                <div className="lg:col-span-5 flex flex-col h-full">
                    <AppCard headerImg={localBGImage}>
                        <div className="mb-4">
                            <span
                                className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Policy Summary</span>
                            <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Your
                                Policy Details</h2>
                            <p className="text-sm text-base-content/70">Review the selected policy and member
                                information.</p>
                        </div>
                        <Divider type="solid" className="opacity-30 my-4"/>

                        <div className="mb-6">
                            <Menu
                                className="border border-base-300 rounded-xl px-4 py-3 w-full bg-base-100 flex justify-between items-center cursor-pointer shadow-sm"
                                trigger={policyMenuTrigger(currentMember.Policy_Number)}
                                items={policyList}
                                getKey={(p) => p.MainMember.Policy_Number}
                                searchable={policyList.length > 5}
                                searchPlaceholder="Search policy number"
                                filterItem={(p, q) =>
                                    p.MainMember.Policy_Number.toLowerCase().includes(q.toLowerCase())
                                }
                                renderItem={(p) => (
                                    <span
                                        className="flex justify-between items-center w-full py-2 border-b border-base-200 last:border-0">
                                        <span className="font-semibold text-base-content">
                                            {p.MainMember.Policy_Number}
                                        </span>
                                    </span>
                                )}
                                onSelect={(p) => updateSelectedPolicy(p, policyList, apiResponse)}
                            />
                        </div>

                        <div className="mb-6 bg-base-200 rounded-xl p-4">
                            <span className="text-xs uppercase font-bold text-base-content/60 block mb-1">Principal Member</span>
                            <strong
                                className="text-lg">{currentMember.Title} {currentMember.First_Name} {currentMember.Surname}</strong>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                            <InfoField label="Monthly Premium" value={`$ ${currentMember.UsualPremium}`}/>
                            <InfoField
                                label="Policy Status"
                                value={<StatusBadge tone={statusTone} label={statusLabel} message={statusMessage}/>}
                            />
                            <InfoField label="Policy Number" value={currentMember.Policy_Number}/>
                            <InfoField label="Policy Product" value={currentMember.Product_Name}/>
                        </div>

                        <div className="mb-6 bg-base-200 rounded-xl p-4">
                            <span
                                className="text-xs uppercase font-bold text-base-content/60 block mb-1">Address</span>
                            <strong className="block">{currentMember.Address}</strong>
                            <small className="text-base-content/70">{currentMember.Region}</small>
                        </div>

                        <Button
                            label="Download Certificate"
                            icon="pi pi-download"
                            className="btn btn-info btn-outline p-button-outlined p-button-info w-full mt-2 font-bold"
                            onClick={() => generateCertificate(currentPolicy)}
                        />
                    </AppCard>
                </div>

                <div className="lg:col-span-7 flex flex-col h-full">
                    <AppCard headerImg={localBGImageBeneficiaries}>
                        <div className="mb-4">
                            <span
                                className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Beneficiaries</span>
                            <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Your
                                Beneficiaries</h2>
                            <p className="text-sm text-base-content/70">Manage who is covered under this policy.</p>
                        </div>
                        <Divider type="solid" className="opacity-30 my-4"/>
                        <Accordion activeIndex={0}>
                            <AccordionTab header="Principal Member Details">
                                <DataTable value={[policyList[policyDisplayKey].MainMember]}
                                           tableStyle={{minWidth: '50rem'}}>
                                    <Column field='ID_Number' header="ID Number"></Column>
                                    <Column field='Title' header="Title"></Column>
                                    <Column field='First_Name' header="First Name"></Column>
                                    <Column field='Surname' header="Last Name"></Column>
                                    <Column field='Date_Of_Birth' header="Date Of Birth"></Column>
                                    <Column field='Gender' header="Gender"></Column>
                                    <Column field='Marital_Status' header="Marital Status"></Column>
                                    {/* <Column field='Address' header="Gender"></Column> */}
                                    <Column field='Cell_Number' header="Cell Number"></Column>
                                </DataTable>
                            </AccordionTab>
                            <Divider type="dotted"/>
                            <AccordionTab header="Beneficiary Details">
                                {policyList[policyDisplayKey].Spouse && policyList[policyDisplayKey].Spouse.length !== 0 ? (<>
                                        <h4 className='dl-beneficiary-subheading'>Spouse Beneficiary Details</h4>
                                        <Divider type="dotted"/>
                                        <DataTable value={[policyList[policyDisplayKey].Spouse]}
                                                   tableStyle={{minWidth: '50rem'}}>
                                            <Column field='Member_ID' header="Member_ID"></Column>
                                            <Column field='ID_Num' header="ID Number"></Column>
                                            <Column field='Name' header="First Name"></Column>
                                            <Column field='Surname' header="Last Name"></Column>
                                            <Column field='Date_of_Birth' header="Date Of Birth"></Column>
                                            <Column field='Gender' header="Gender"></Column>
                                            <Column field='Telephone' header="Phone Number"></Column>
                                            <Column header="Actions"
                                                    body={(rowData) => actionBodyTemplate(rowData, 'SPOUSE')}/>
                                        </DataTable></>) :
                                    <><small className="dl-empty-hint">No Spouse Beneficiary Details</small><Divider
                                        type="dotted"/>
                                    </>}

                                <BeneficiaryGroup
                                    title="Children Beneficiary Details"
                                    emptyText="No Child Beneficiary Details"
                                    items={policyList[policyDisplayKey].Children}
                                    keyField="ID_num"
                                    columns={CHILD_COLUMNS}
                                    relationshipType="CHILD"
                                    actionBodyTemplate={actionBodyTemplate}
                                />
                                <BeneficiaryGroup
                                    title="Extended Family Beneficiary Details"
                                    emptyText="No Extended Family Beneficiary Details"
                                    items={policyList[policyDisplayKey].ExtendedFamiy}
                                    keyField="ID_num"
                                    columns={EXTENDED_COLUMNS}
                                    relationshipType="FAMILY_MEMBER"
                                    actionBodyTemplate={actionBodyTemplate}
                                />
                                <BeneficiaryGroup
                                    title="Other Beneficiary Details"
                                    emptyText="No Other Beneficiary Details"
                                    items={policyList[policyDisplayKey].memberBeneficiary}
                                    keyField="IdNumber"
                                    columns={OTHER_COLUMNS}
                                    relationshipType="BENEFICIARY"
                                    actionBodyTemplate={actionBodyTemplate}
                                />

                                <ConfirmPopup/>
                                <div className="dl-add-beneficiary">
                                    <p>Add your spouse, children and relative beneficiaries to your existing
                                        policy.</p>
                                    <button
                                        type="button"
                                        className="btn bg-[#135A9C] hover:bg-[#0e4475] text-white border-none rounded-xl"
                                        onClick={openAddDialog}
                                    >
                                        Add New Beneficiary
                                    </button>
                                </div>
                            </AccordionTab>
                            <AccordionTab header="Banking Details">
                                {policyList[policyDisplayKey].BankDetail && policyList[policyDisplayKey].BankDetail.length !== 0 ? (
                                    <>
                                        {policyList[policyDisplayKey].BankDetail.map((bankDetail) => (
                                            <DataTable key={bankDetail.Account_Name} value={[bankDetail]}
                                                       tableStyle={{minWidth: '50rem'}}>
                                                {/* <Column field='BankName' header="Bank Name"></Column>
                                                        <Column field='BranchName' header="Branch Name"></Column> */}
                                                <Column field='Account_Name' header="Account Name"></Column>
                                                <Column field='Account_Number' header="Account Number"></Column>
                                                <Column field='Type_of_Account' header="Type of Account"></Column>
                                            </DataTable>
                                        ))}
                                    </>) : <></>}

                            </AccordionTab>
                        </Accordion>
                        <Divider type='dotted'/>


                    </AppCard>
                </div>
            </div> : <h5>Select policy to display</h5>}
    </>);
}

const ManagePolicy = () => {

    const toast = useRef(null);
    const [balanceDetails, setBalanceDetails] = useState(null);
    const [policyDisplay, setPolicyDisplay] = useState(null);
    const [selectedPolicy, setSelectedPolicy] = useState(null);

    const [loading, setLoading] = useState(true);

    const [policyDisplayKey, setPolicyDisplayKey] = useState(1);
    let userProfile = {};
    const [newBenVisible, setNewBenVisible] = useState(false);

    // Beneficiary change-request form state
    const [beneficiaryDialog, setBeneficiaryDialog] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [selectedBen, setSelectedBen] = useState(null);
    const [deleteReason, setDeleteReason] = useState('');

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        idNumber: '',
        passportNumber: '',
        title: 'Mr',
        gender: 'MALE',
        relationship: 'CHILD',
        dateOfBirth: '',
        emailAddress: '',
        phoneNumber: '',
        reason: ''
    });

    const openAddDialog = () => {
        setIsEditMode(false);
        setFormData({
            firstName: '',
            lastName: '',
            idNumber: '',
            passportNumber: '',
            title: 'Mr',
            gender: 'MALE',
            relationship: 'CHILD',
            dateOfBirth: '',
            emailAddress: '',
            phoneNumber: '',
            reason: ''
        });
        setFormErrors({});
        setBeneficiaryDialog(true);
    };

    const openEditDialog = (ben, relationshipType) => {
        setIsEditMode(true);
        setSelectedBen({...ben, relationshipType});

        let dobStr = ben.Date_of_Birth || ben.Date_of_birth || ben.BenDOB || '';
        if (dobStr?.includes('T')) {
            dobStr = dobStr.split('T')[0];
        }

        setFormData({
            firstName: ben.Name || ben.FirstName || ben.BenName || '',
            lastName: ben.Surname || ben.LastName || ben.BenSurname || '',
            idNumber: ben.ID_num || ben.ID_Num || ben.IdNumber || ben.BenID || '',
            passportNumber: ben.PassportNumber || ben.Passport_num || '',
            title: ben.Title || ben.BenTitle || 'Mr',
            gender: ben.Gender || ben.BenGender || 'MALE',
            relationship: relationshipType,
            dateOfBirth: dobStr,
            emailAddress: ben.EmailAddress || ben.emailAddress || '',
            phoneNumber: ben.Telephone || ben.phoneNumber || ben.BenTelephone || '',
            reason: ''
        });
        setFormErrors({});
        setBeneficiaryDialog(true);
    };

    const openDeleteDialog = (ben, relationshipType) => {
        setSelectedBen({...ben, relationshipType});
        setDeleteReason('');
        setDeleteDialog(true);
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.firstName.trim()) errors.firstName = 'First name is required';
        if (!formData.lastName.trim()) errors.lastName = 'Last name is required';
        if (!formData.idNumber.trim()) errors.idNumber = 'ID number is required';
        if (!formData.title.trim()) errors.title = 'Title is required';
        if (!formData.gender.trim()) errors.gender = 'Gender is required';
        if (!formData.relationship.trim()) errors.relationship = 'Relationship is required';
        if (!formData.dateOfBirth) errors.dateOfBirth = 'Date of birth is required';
        if (!formData.reason.trim()) errors.reason = 'Reason is required';

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFormSubmit = async () => {
        if (!validateForm()) return;
        setSubmitting(true);
        try {
            const activePolicy = selectedPolicy || (balanceDetails?.[policyDisplayKey]);
            const policyNumber = activePolicy ? activePolicy.MainMember.Policy_Number : '';
            if (!policyNumber) {
                toast.current.show({severity: 'error', summary: 'Error', detail: 'No active policy selected'});
                setSubmitting(false);
                return;
            }

            const payload = {
                operation: isEditMode ? 'UPDATE' : 'ADD',
                details: {
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    idNumber: formData.idNumber,
                    passportNumber: formData.passportNumber,
                    title: formData.title,
                    gender: formData.gender,
                    relationship: formData.relationship,
                    dateOfBirth: formData.dateOfBirth,
                    emailAddress: formData.emailAddress,
                    phoneNumber: formData.phoneNumber
                },
                reason: formData.reason
            };

            if (isEditMode) {
                const benId = selectedBen.SpouseID || selectedBen.Child_ID || selectedBen.ExtendedFam_ID || selectedBen.BeneficiaryID;
                const memberId = selectedBen.Member_ID || activePolicy.MainMember.Member_ID;
                const editPayload = {
                    memberId: Number(memberId),
                    beneficiaryId: Number(benId),
                    operation: 'UPDATE',
                    details: payload.details,
                    reason: formData.reason
                };
                const res = await editBeneficiary(policyNumber, editPayload);
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: res.data.message || 'Beneficiary change requested successfully'
                });
            } else {
                const res = await addBeneficiary(policyNumber, payload);
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: res.data.message || 'Beneficiary change requested successfully'
                });
            }
            setBeneficiaryDialog(false);
            getPolicyDetails();
        } catch (err) {
            console.error(err);
            const errMsg = err.response?.data?.message || err.message || 'An error occurred';
            toast.current.show({severity: 'error', summary: 'Failed', detail: errMsg});
        } finally {
            setSubmitting(false);
        }
    };

    const handleDeleteSubmit = async () => {
        if (!deleteReason.trim()) {
            toast.current.show({severity: 'warn', summary: 'Required', detail: 'Please provide a reason for deletion'});
            return;
        }
        setSubmitting(true);
        try {
            const activePolicy = selectedPolicy || (balanceDetails?.[policyDisplayKey]);
            const policyNumber = activePolicy ? activePolicy.MainMember.Policy_Number : '';
            const benId = selectedBen.SpouseID || selectedBen.Child_ID || selectedBen.ExtendedFam_ID || selectedBen.BeneficiaryID;
            const memberId = selectedBen.Member_ID || activePolicy.MainMember.Member_ID;

            const payload = {
                memberId: Number(memberId),
                beneficiaryId: Number(benId),
                reason: deleteReason
            };

            const res = await deleteBeneficiary(policyNumber, payload);
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: res.data.message || 'Delete request submitted successfully'
            });
            setDeleteDialog(false);
            getPolicyDetails();
        } catch (err) {
            console.error(err);
            const errMsg = err.response?.data?.message || err.message || 'An error occurred';
            toast.current.show({severity: 'error', summary: 'Failed', detail: errMsg});
        } finally {
            setSubmitting(false);
        }
    };

    const actionBodyTemplate = (rowData, relationshipType) => {
        return (
            <div className="flex gap-2">
                <Button
                    icon="pi pi-pencil"
                    className="btn btn-warning btn-sm p-button-rounded p-button-warning p-button-sm mr-2"
                    onClick={() => openEditDialog(rowData, relationshipType)}
                    tooltip="Edit"
                />
                <Button
                    icon="pi pi-trash"
                    className="btn btn-error text-white btn-sm p-button-rounded p-button-danger p-button-sm"
                    onClick={() => openDeleteDialog(rowData, relationshipType)}
                    tooltip="Delete"
                />
            </div>
        );
    };

    function parseTrackApplicationResponse(apiResponse, policyDisplayKey) {
        setLoading(false)
        // //console.log(apiResponse);
        if (apiResponse?.responseBody && !(Array.isArray(apiResponse.responseBody)) && apiResponse.responseBody.policyApplicationRequestId) {
            //console.log("---- Yes");
            return <NewApplicationPolicyDisplay applicationDetail={apiResponse.responseBody}/>;

        } else if (apiResponse?.responseBody && (Array.isArray(apiResponse.responseBody)) && apiResponse.responseBody.length > 0) {
            //console.log("---- NO");
            return <EasipolPolicyDisplay key={policyDisplayKey} policyList={apiResponse.responseBody}
                                         policyDisplayKey={policyDisplayKey} apiResponse={apiResponse}
                                         updateSelectedPolicy={updateSelectedPolicy} openAddDialog={openAddDialog}
                                         actionBodyTemplate={actionBodyTemplate} generateCertificate={generateCertificate}/>;

        } else {
            //console.log("---- MAYbe");

            return <NewApplicationPolicyDisplay applicationDetail={apiResponse.responseBody}/>;
        }
    }


    useEffect(() => {
        // fetchActiveProducts()
        //console.log("policyDisplayKey updated:", policyDisplayKey);
    }, [policyDisplayKey]);

    function updateSelectedPolicy(policyValue, policyList, apiResponse) {
        let policyDisplayKey = policyList.findIndex(item => item.MainMember.Policy_Number === policyValue.MainMember.Policy_Number);
        setPolicyDisplayKey(policyList.findIndex(item => item.MainMember.Policy_Number === policyValue.MainMember.Policy_Number));
        setPolicyDisplay(parseTrackApplicationResponse(apiResponse, policyDisplayKey));

        setSelectedPolicy(policyList[policyDisplayKey])
    }

    const generateCertificate = async (policy) => {
        const targetPolicy = policy || selectedPolicy || (balanceDetails?.[policyDisplayKey]);
        if (!targetPolicy?.MainMember) return;

        toast.current?.show({
            severity: 'info',
            summary: 'Please wait',
            detail: 'Generating your certificate...',
            life: 2000
        });

        const activePolicy = await fetchFullPolicy(targetPolicy, targetPolicy.MainMember.Policy_Number);

        const img = new Image();
        img.onload = () => drawCertificate(activePolicy, img);
        img.onerror = () => drawCertificate(activePolicy, null);
        img.src = logoImg;
    };

    const getPolicyDetails = async () => {
        setLoading(true)
        try {
            userProfile = (StorageHelper.get('userProfile'));

            await apiClient.get('policy/track/' + userProfile.idnumber, {
                headers: {
                    Authorization: 'Bearer ' + (StorageHelper.get('token'))
                }
            }).then((response) => {

                if (response.data.status === "SUCCESS") {
                    // //console.log(response);

                    if (response.data.responseBody !== null) {
                        setBalanceDetails(response.data.responseBody);
                        if (Array.isArray(response.data.responseBody) && response.data.responseBody.length > 0) {
                            setSelectedPolicy(response.data.responseBody[0]);
                        }
                    }

                } else {
                    // //console.log(response.data.status)
                }
                // //console.log(userProfile.idnumber);
                // //console.log(response.data);
                setLoading(false)
                setPolicyDisplay(parseTrackApplicationResponse(response.data, 0))
            });

        } catch (error) {
            setLoading(false)
            console.error('Error fetching balance details:', error);
        }
    };

    useMountEffect(() => {
        getPolicyDetails();
    }, []);

    return (
        <>
            <Toast ref={toast}/>
            <Header/>
            <DynamicNavigation/>
            <div className="min-h-screen bg-base-200 pt-28 pb-8">
                <div className="container mx-auto px-4 max-w-7xl">
                    <div className="w-full">
                        {loading ? (
                                <div className="border-round border-1 surface-border p-4 surface-card">
                                    <div className="flex mb-3">
                                        <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                                        <div>
                                            <Skeleton width="10rem" className="mb-2"></Skeleton>
                                            <Skeleton width="5rem" className="mb-2"></Skeleton>
                                            <Skeleton height=".5rem"></Skeleton>
                                        </div>
                                    </div>
                                    <Skeleton width="100%" height="150px"></Skeleton>
                                    <div className="flex justify-content-between mt-3">
                                        <Skeleton width="4rem" height="2rem"></Skeleton>
                                        <Skeleton width="4rem" height="2rem"></Skeleton>
                                    </div>
                                </div>) :
                            <div className="col-xxl-12 col-xl-12 col-lg-12">
                                {policyDisplay && policyDisplayKey ? policyDisplay : <>{policyDisplay}</>}
                            </div>}
                    </div>
                </div>
            </div>

            {/* Add/Edit Beneficiary Dialog */}
            <BeneficiaryDialog
                visible={beneficiaryDialog}
                onClose={() => setBeneficiaryDialog(false)}
                isEditMode={isEditMode}
                formData={formData}
                setFormData={setFormData}
                formErrors={formErrors}
                submitting={submitting}
                onSubmit={handleFormSubmit}
            />


                {/* Delete Beneficiary Dialog */}
                <Dialog
                    className="dl-dialog"
                    header="Confirm Delete Beneficiary"
                    visible={deleteDialog}
                    style={{width: '400px'}}
                    modal
                    onHide={() => setDeleteDialog(false)}
                >
                    <div className="p-fluid">
                        <p>Are you sure you want to request deletion of this beneficiary?</p>
                        {selectedBen && (
                            <div className="card p-3 mb-3 bg-light">
                                <strong>Name:</strong> {selectedBen.Name || selectedBen.FirstName || selectedBen.BenName} {selectedBen.Surname || selectedBen.LastName || selectedBen.BenSurname}<br/>
                                <strong>Relationship:</strong> {selectedBen.relationshipType}
                            </div>
                        )}
                        <div className="field mb-3">
                            <label htmlFor="deleteReason" className="form-label">Reason for Deletion *</label>
                            <textarea
                                id="deleteReason"
                                rows={3}
                                className="form-control"
                                placeholder="Please provide a reason for deleting this beneficiary"
                                value={deleteReason}
                                onChange={(e) => setDeleteReason(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="flex justify-content-end gap-2 mt-4 text-right">
                        <Button label="Cancel" className="btn btn-secondary p-button-text p-button-secondary mr-2"
                                onClick={() => setDeleteDialog(false)}/>
                        <Button className="btn btn-error text-white" label={submitting ? "Deleting..." : "Confirm Delete"} severity="danger"
                                icon="pi pi-trash"
                                onClick={handleDeleteSubmit} disabled={submitting}/>
                    </div>
                </Dialog>

                <Dialog className="dl-dialog" header="Add New Beneficiary" visible={newBenVisible}
                        style={{width: '20vw'}}
                        onHide={() => {
                            setNewBenVisible(false)
                        }}>
                    <AddBeneficiaryMembers policyDisplay={policyDisplay}/>
                </Dialog>
        </>
    );
}

export default ManagePolicy;
